import Vue from 'vue'
import Vuex from 'vuex'
import VueAxios from 'vue-axios'
import { VueAuthenticate } from 'vue-authenticate'
import axios from 'axios';
import moment from 'moment'
import axiosclient from '../../utils/axiosclient';
Vue.use(Vuex)
Vue.use(VueAxios, axios)

const ENDPOINT_PROJECTS= "/v2/projects"
const ENDPOINT_TASKS= "/v2/tasks"
const ENDPOINT_PUBLIC_PROJECTS= "/v2/public/project"


const state = {
    projects: null,
    archievedProjects: null,
    histories: [],
    tasks: null,
    demoProjects: null,
    project:null
}

const getters = {
    
}

const mutations = {
    setProjects: (state, payload) => {
        state.projects = payload
    },
    setArchievedProjects: (state, payload) => {
        state.archievedProjects = payload
    },
    setDemoProjects: (state, payload) => {
        state.demoProjects = payload
    },
    setTasks: (state, payload) => {
        state.tasks = payload
    },

    setSingleProject: (state, payload) => {
        state.project = payload
    },
    setHistories: (state, payload) => {
        state.histories = payload
    },
}

const actions = {
   
    fetchAllProjects({commit, rootState}, payload) {
        commit('setLoading', true, {root: true})
        return axiosclient.get(ENDPOINT_PROJECTS).then(({data}) => {

            let projects = data.data.sort((a, b) => {
                return moment(a.start_date).diff(moment(b.start_date))
            }).map(r => {
                r.assigned_to_client = r.asset_users 
                r.assigned_by_client = r.user_owner 
                
                r.start_date = r.start_date?moment(r.start_date).format("DD-MM-YYYY 00:00:00") : moment().format("DD-MM-YYYY 00:00:00")
                r.end_date = r.end_date?moment(r.end_date).format("DD-MM-YYYY 23:59:00") : moment().add(1, "days").format("DD-MM-YYYY 23:59:00")
                
                if(r.task && r.task.length == 0) {
                    r.readonly = false
                }
                r.readonly = false
                r.finance = 100
                if(r.id == "assigned-tasks") {
                    r.which_task = "left"
                }
                r.showBilling = r.finance || false

                if(r.is_archieved == 1) {
                    r.color = "gray"
                }
                if(r.end_date) {
                    let sd = moment(r.start_date)
                    let ed = moment(r.end_date);
                    r.duration = ed.diff(sd, 'days')
                } else {
                    r.duration = 1
                }
                return r;
                
            })

           // \commit('setLoading', false, {root: true})
            //console.log("========", projects)
            commit('setProjects', {data: projects})
            return Promise.resolve(true)
        }).catch(err => {
            commit('setLoading', false, {root: true})
            console.log(err)
            return Promise.reject(false)
        })
    }, 


    fetchArchievedProjects({commit, rootState}, payload) {
        commit('setLoading', true, {root: true})
        return axiosclient.get(ENDPOINT_PROJECTS+'/archieved').then(({data}) => {

            let projects = data.data.map(r => {
                r.assigned_to_client = r.asset_users 
                r.assigned_by_client = r.user_owner 
                
                r.start_date = r.start_date?moment(r.start_date).format("DD-MM-YYYY 00:00:00") : moment().format("DD-MM-YYYY 00:00:00")
                r.end_date = r.end_date?moment(r.end_date).format("DD-MM-YYYY 23:59:00") : moment().add(1, "days").format("DD-MM-YYYY 23:59:00")
                if(r.task && r.task.length == 0) {
                    r.readonly = true
                }
                r.finance = 100
                if(r.id == "assigned-tasks") {
                    r.which_task = "left"
                }
                r.showBilling = r.finance || false
                if(r.end_date) {
                    let sd = moment(r.start_date)
                    let ed = moment(r.end_date);
                    r.duration = ed.diff(sd, 'days')
                } else {
                    r.duration = 1
                }
                return r;
                
            })
            //commit('setLoading', false, {root: true})
            commit('setArchievedProjects', {data: projects})
            return Promise.resolve(true)
        }).catch(err => {
            commit('setLoading', false, {root: true})
            console.log(err)
            return Promise.reject(err)
        })
    }, 

    fetchSingleProject({commit}, payload, quote=false) {
        // commit('setLoading', true, {root: true})
        return axiosclient.get(ENDPOINT_PROJECTS+"/"+payload+"?quote="+quote).then((res) => {
            commit('setSingleProject', res.data.data)
            //commit('setLoading', false, {root: true})
            return Promise.resolve(res.data)
        }).catch(err => {
            console.log(err)
            //commit('setLoading', false, {root: true})
            return Promise.reject(err)
        })
    }, 

    fetchAllDemoProjects({commit}, payload) {
        return axiosclient.get(ENDPOINT_PUBLIC_PROJECTS).then(({data}) => {

            let projects = data.data.map(r => {
                r.assigned_to_client = r.user_admin
                r.assigned_by_client = r.user_owner
                r.start_date = r.start_date?moment(r.start_date).format("DD-MM-YYYY 00:00:00") : moment().format("DD-MM-YYYY 00:00:00")
                r.end_date = r.end_date?moment(r.end_date).format("DD-MM-YYYY 23:59:00") : moment().add(1, "days").format("DD-MM-YYYY 23:59:00")
                r.finance = 100
                r.showBilling = r.finance || false
                if(r.task && r.task.length == 0) {
                    r.readonly = true
                }
                if(r.end_date) {
                    let sd = moment(r.start_date)
                    let ed = moment(r.end_date);
                    r.duration = ed.diff(sd, 'days')
                } else {
                    r.duration = 1
                }
                return r;
                
            })

            commit('setDemoProjects', {data: projects})
            return Promise.resolve(true)
        }).catch(err => {
            console.log(err)
            return Promise.reject(false)
        })
    },    

    createProject({commit, rootState}, payload) {
        commit('setLoading', true, {root: true})
        return axiosclient.post(ENDPOINT_PROJECTS, payload).then(res => {
            commit('setLoading', false, {root: true})
            return Promise.resolve(true)
        }).catch(err => {
            commit('setLoading', false, {root: true})
            return Promise.reject(false)
        })
    },  

    updateProject({commit, rootState}, payload) {
        commit('setLoading', true, {root: true})
        return axiosclient.put(ENDPOINT_PROJECTS+'/'+payload.id, payload).then(res => {
            commit('setLoading', false, {root: true})
            return Promise.resolve(true)
        }).catch(err => {
            commit('setLoading', false, {root: true})
            return Promise.reject(false)
        })
    },

    updateProjectArchieveStatus({commit, rootState}, payload) {
        commit('setLoading', true, {root: true})
        return axiosclient.put(ENDPOINT_PROJECTS+'/change-archieve-status', payload).then(res => {
            commit('setLoading', false, {root: true})
            return Promise.resolve(true)
        }).catch(err => {
            commit('setLoading', false, {root: true})
            return Promise.reject(false)
        })
    },

    updateProjectStatus({ commit, rootState }, payload) {
        //commit('setLoading', true, {root: true})
        return axiosclient
          .put(ENDPOINT_PROJECTS + "/project-deadline" + "/" + payload.id, payload)
          .then(res => {
            //commit('setLoading', false, {root: true})
            //   if (res.data.error == false) {
                   return Promise.resolve(res);
            //   }
            //   return Promise.resolve(false);       
          })
          .catch(err => {
            //commit('setLoading', false, {root: true})
            return Promise.reject(false);
          });
      },


      invitePayersToProject({ commit, rootState }, payload) {
        commit('setLoading', true, {root: true})
        return axiosclient
          .post("projects/add-payer", payload)
          .then(res => {
                commit('setLoading', false, {root: true})
                return Promise.resolve(res.data);       
          })
          .catch(err => {
            commit('setLoading', false, {root: true})
            return Promise.reject(err);
          });
      },


      createPayement({ commit, rootState }, payload) {
        commit('setLoading', true, {root: true})
        return axiosclient
          .post("v2/billing/account", payload)
          .then(res => {
                commit('setLoading', false, {root: true})
                return Promise.resolve(res.data);       
          })
          .catch(err => {
            commit('setLoading', false, {root: true})
            return Promise.reject(err);
          });
      },


      updatePayement({ commit, rootState }, payload) {
        commit('setLoading', true, {root: true})
        return axiosclient
          .post("/v2/billing/update-card", payload)
          .then(res => {
                commit('setLoading', false, {root: true})
                return Promise.resolve(res.data);       
          })
          .catch(err => {
            commit('setLoading', false, {root: true})
            return Promise.reject(err);
          });
      },

    searchProject({commit, rootState}, payload) {
    
        // return axiosclient.get("/project/search?query="+payload).then((res) => {
        //     return Promise.resolve(res.data)
        // }).catch(err => {
        //     return Promise.reject(err)
        // })

        commit('setLoading', true, {root: true})
        return axiosclient.get("/v2/search-projects", {params: payload}).then(({data}) => {

            let projects = data.data.map(r => {
                r.assigned_to_client = r.asset_users 
                r.assigned_by_client = r.user_owner 
                
                r.start_date = r.start_date?moment(r.start_date).format("DD-MM-YYYY 00:00:00") : moment().format("DD-MM-YYYY 00:00:00")
                r.end_date = r.end_date?moment(r.end_date).format("DD-MM-YYYY 23:59:00") : moment().format("DD-MM-YYYY 23:59:00")
                if(r.task && r.task.length == 0) {
                    r.readonly = true
                }
                r.finance = 100
                if(r.id == "assigned-tasks") {
                    r.which_task = "left"
                }

                

              
                if(r.is_archieved == 1) {
                  r.color = "gray"
                }

                r.showBilling = r.finance || false
                if(r.end_date) {
                    let sd = moment(r.start_date)
                    let ed = moment(r.end_date);
                    r.duration = ed.diff(sd, 'days')
                } else {
                    r.duration = 1
                }
                return r;
                
            })
            commit('setLoading', false, {root: true})
            //commit('setProjects', {data: projects})
            return Promise.resolve({data: projects})
        }).catch(err => {
            commit('setLoading', false, {root: true})
            console.log(err)
            return Promise.reject(false)
        })
    
    },

    fetchPaymentInfo({commit}, id) {
        // commit('setLoading', true, {root: true})
        return axiosclient.get("projects/payment-info/"+id).then((res) => {
            return Promise.resolve(res.data)
        }).catch(err => {
            console.log(err)
            //commit('setLoading', false, {root: true})
            return Promise.reject(err)
        })
    }, 

    fetchBillingProjects({commit}, type) {
        // commit('setLoading', true, {root: true})
        return axiosclient.get("projects/"+type).then((res) => {
            return Promise.resolve(res.data.data)
        }).catch(err => {
            console.log(err)
            //commit('setLoading', false, {root: true})
            return Promise.reject(err)
        })
    }, 
    fetchProjectHistories({commit}, id) {
        // commit('setLoading', true, {root: true})
        return axiosclient.get("v2/asset/"+id+"/histories").then((res) => {
            commit('setHistories', res.data.data)
            return Promise.resolve(res.data.data)
        }).catch(err => {
            console.log(err)
            //commit('setLoading', false, {root: true})
            return Promise.reject(err)
        })
    }, 

    requestApproval({ commit, rootState }, payload) {
        commit('setLoading', true, {root: true})
        return axiosclient
          .post("projects/request-approval", payload)
          .then(res => {
                commit('setLoading', false, {root: true})
                return Promise.resolve(res.data);       
          })
          .catch(err => {
            commit('setLoading', false, {root: true})
            return Promise.reject(err);
          });
      },


    changeApprovalStatus({ commit, rootState }, payload) {
        commit('setLoading', true, {root: true})
        return axiosclient
          .post("projects/approvals", payload)
          .then(res => {
                commit('setLoading', false, {root: true})
                return Promise.resolve(res.data);       
          })
          .catch(err => {
            commit('setLoading', false, {root: true})
            return Promise.reject(err);
          });
      },

      changeApprovalStatusV2({ commit, rootState }, payload) {
        commit('setLoading', true, {root: true})
        return axiosclient
          .post("v2/projects/approvals", payload)
          .then(res => {
                commit('setLoading', false, {root: true})
                return Promise.resolve(res.data);       
          })
          .catch(err => {
            commit('setLoading', false, {root: true})
            return Promise.reject(err);
          });
      },


}

export default {
namespaced: true,
state,
getters,
mutations,
actions
}